var _text, _text2, _line, _text3, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWilsontamukalogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 160",
    width: 460,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 45,
    fontFamily: "'Times New Roman', Times, serif",
    fontWeight: "bold",
    fontSize: 42,
    fill: "#FFFFFF",
    textAnchor: "middle",
    letterSpacing: 4
  }, "\n\xA0 \xA0 WILSON TAMUKA\n\xA0 ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 90,
    fontFamily: "'Times New Roman', Times, serif",
    fontSize: 28,
    fill: "#FFFFFF",
    textAnchor: "middle",
    letterSpacing: 3
  }, "\n\xA0 \xA0 ATTORNEYS\n\xA0 ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 110,
    x2: 160,
    y2: 110,
    stroke: "#CCCCCC",
    strokeWidth: 3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 130,
    fontFamily: "'Times New Roman', Times, serif",
    fontSize: 18,
    fill: "#FFFFFF",
    textAnchor: "middle",
    letterSpacing: 6
  }, "\n\xA0 \xA0 LAW FIRM\n\xA0 ")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 150,
    x2: 450,
    y2: 150,
    stroke: "#CCCCCC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWilsontamukalogo);
export default __webpack_public_path__ + "static/media/wilsontamukalogo.8bdf1f2ef1593dd3e0cacb465f8aa8dc.svg";
export { ForwardRef as ReactComponent };